import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const badges = ["未経験OK", "シニア歓迎", "日払いOK", "週払いOK", "入社祝い金あり"];

export default function RecruitCtaSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  return (
    <section id="recruit-cta" className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none"
        style={{
          backgroundImage:
            "url('/images/GRANSTARK-staff5_training_meeting_room.jpeg')",
        }}
      />
      <div className="absolute inset-0 bg-navy/85 pointer-events-none" />

      <div ref={ref} className="relative z-10 w-full px-4 md:px-8 max-w-4xl mx-auto text-center">
        <h2
          className={`text-xl md:text-3xl lg:text-4xl font-black text-white leading-tight mb-6 drop-shadow-lg transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          今すぐ働ける。未経験でも、シニアでも。
        </h2>

        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {badges.map((badge) => (
            <span
              key={badge}
              className="bg-[#f0ece3] text-navy text-sm font-bold px-5 py-2 rounded-full"
            >
              {badge}
            </span>
          ))}
        </div>

        <div className="mb-10">
          <p className="text-white text-lg mb-2">未経験からでも月30万円以上可能</p>
          <p className="text-5xl md:text-7xl font-black text-white">
            月収 30万円～
          </p>
        </div>

        <Link
          to="/recruit"
          className="inline-flex items-center justify-center gap-2 bg-[#E47911] text-white font-bold text-lg px-10 py-5 rounded-full transition-all duration-300 hover:bg-[#E47911]/90 hover:scale-105 whitespace-nowrap"
        >
          採用情報・応募はこちら
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}